import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Badge } from "@/shared/components/ui/badge";
import { Button } from "@/shared/components/ui/button";
import { Plus, ExternalLink, Settings, Download } from "lucide-react";

const apps = [
  {
    id: 1,
    name: "CRM Integration",
    description: "Sync your contacts and deals with popular CRM platforms",
    status: "active",
    category: "Integration",
    icon: "",
  },
];

const AppsPage = () => {
  return (
    <div className="p-6 space-y-6 bg-background min-h-screen">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold">Apps & Integrations</h1>
        <p className="text-muted-foreground">
          Extend your workflow with powerful integrations and applications
        </p>
      </div>

      {/* Apps Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {apps.map((app) => (
          <Card key={app.id} className="hover:shadow-md transition-shadow relative overflow-hidden">
            <CardHeader className="pb-3">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3 text-left">
                  <div className="text-2xl">{app.icon}</div>
                  <div className="text-left">
                    <CardTitle className="text-lg text-left">{app.name}</CardTitle>
                    <Badge 
                      variant={app.status === "active" ? "default" : "secondary"}
                      className="mt-1"
                    >
                      {app.status}
                    </Badge>
                  </div>
                </div>
                <Button variant="ghost" size="sm">
                  <Settings className="h-4 w-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="pt-0 text-left">
              <p className="text-sm text-muted-foreground mb-4 text-left">
                {app.description}
              </p>
              <div className="flex items-center justify-between">
                <Badge variant="outline">{app.category}</Badge>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm">
                    <ExternalLink className="h-3 w-3 mr-1" />
                    View
                  </Button>
                  {app.status === "inactive" && (
                    <Button size="sm">
                      <Download className="h-3 w-3 mr-1" />
                      Install
                    </Button>
                  )}
                </div>
              </div>
            </CardContent>
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm flex flex-col items-center justify-center text-white space-y-3">
              <p className="text-lg font-semibold">Coming Soon</p>
              <p className="text-sm text-center max-w-[220px] text-white/80 px-4">
                CRM integrations are on the way. Stay tuned!
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AppsPage;
